import {
  Slider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import Help from "~/components/common/Help";

type Weights = {
  driveWeight: number,
  proximityWeight: number,
  utilizationWeight: number,
  shiftShorteningPenaltyWeight: number,
}

type Props = {
  weights: Weights,
  setWeights: (weights: Weights) => void
}

const VisitWeightConfig = ({ weights, setWeights }: Props) => {
  const handleWeightChange = (_event: any, newWeights: number | number[]) => {
    if (!Array.isArray(newWeights)) { return; }
    setWeights({
      driveWeight: newWeights[0],
      proximityWeight: newWeights[1] - newWeights[0],
      utilizationWeight: 100 - newWeights[1],
      shiftShorteningPenaltyWeight: 0,
    })
  }

  return <>
    <Table sx={{ maxWidth: 400 }} aria-label="Visit Scoring" size="small">
      <TableHead>
        <TableRow>
          <TableCell>
            Drive Time
            <Help text="Prefer visits that require less drive time from the provider" />
          </TableCell>
          <TableCell>
            Sooner Visits
            <Help text="Prefer to schedule visits sooner rather than later" />
          </TableCell>
          <TableCell>
            Fill Shifts
            <Help text="Prefer to fill shifts that already have visits scheduled rather than schedule into empty shifts" />
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell align="center">{weights.driveWeight}%</TableCell>
          <TableCell align="center">{weights.proximityWeight}%</TableCell>
          <TableCell align="center">{weights.utilizationWeight}%</TableCell>
        </TableRow>
      </TableBody>
    </Table>
    <Slider
      sx={{ maxWidth: 400, marginTop: -1 }}
      value={[weights.driveWeight, weights.driveWeight + weights.proximityWeight]}
      onChange={handleWeightChange}
      track="normal"
    />
  </>
}

export default VisitWeightConfig
